import Outcomes from './outcomes_view';

export default Outcomes;
